export default __webpack_public_path__ + "static/media/orkun-azap-_c7haaSAcIg-unsplash.428bb404.jpg";